<template>
  <div>
    <h1 class="font-semibold text-[28px] text-black">{{ pageTitle }}</h1>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    pageTitle: String,
  },
};
</script>

<style></style>
